import React from 'react'
import GenericMenu from './source/GenericMenuProject';
import { SLUGS } from 'src/enum/permissions.enum';

const TENDER_MENU = {
  our: [
    { check: SLUGS.TENDER.ALL, to: '/tender/our', primary: 'Список', add: true },
  ],
  all: [
    { check: SLUGS.TENDER.ALL, to: '/tender/all/open', primary: 'Открытые тендеры', add: false },
    { check: SLUGS.TENDER.ALL, to: '/tender/all/close', primary: 'Закрытые тендеры', add: false },
    { check: SLUGS.TENDER.ALL, to: '/tender/all/my-request', primary: 'Участник тендера', add: false },
  ],
}
const TENDER_SECTION= {
our:'Мои тендеры',
all:'Все тендеры',
}

export default function TenderMenu(props) {
  return (
    <GenericMenu
      menuConfig={TENDER_MENU}
      sectionsMap={TENDER_SECTION}
      propsRouter={props}
    />
  );
}